import { createFileRoute, notFound } from "@tanstack/react-router";

import { deviceErrorsQueries } from "@/api/resources/deviceErrors/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import DeviceErrorPage from "@/components/DeviceError/DeviceErrorPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/device-data/errors/$device_error_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: `${i18n.t("navigation.device-data")} - ${i18n.t("errors")}`,
        icon: <Icon.INSIGHTS />,
        path: "/workspaces/$workspace_id/device-data/errors",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, device_error_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeviceError = await context.queryClient.ensureQueryData(
      deviceErrorsQueries.byId(Number(device_error_id)),
    );
    if (!currentDeviceError) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [{ label: currentDeviceError.title, icon: <Icon.ERROR /> }];
    context.breadcrumbs.splice(2, 1, ...breadcrumbs);

    return currentDeviceError;
  },
  component: DeviceErrorPage,
});
